import { combineReducers } from 'redux';

import { reducerValidaLogin } from './modulos/congresso/login';
import { reducerToken } from './modulos/tokens/tokenReducers';
import { reducerTraducoes, traducoesNovaAtualizaReducer } from './modulos/traducoes/traducoesReducers';
import { pesquisaTratamentoReducer } from './modulos/credenciamento/tratamento';
import { pesquisaCargosReducer } from './modulos/credenciamento/cargos';
import { reducerPesquisaItem } from './modulos/produto/item';
import { reducerPesquisaSubitem, reducerSubitemSelecionado, reducerSubitemNovoAtualiza } from './modulos/produto/subitem';
import { reducerPesquisaProdPreco, reducerProdPrecoNovoAtualiza, reducerProdPrecoSelecionado } from './modulos/produto/precoprods';
import { reducerPesquisaCodigoPromocional, reducerCodigoPromocionalSelecionado, reducerCodigoPromocionalNovoAtualiza } from './modulos/produto/codigoPromocional';
import { reducerPesquisaPedidosItens } from './modulos/produto/pedidosItens';
import { getCredencialReducer, pesquisaCadastroReducer, pesquisaCredencialComPedidoReducer } from './modulos/credenciamento/credencial';
import { pesquisaPaisesReducer, tipologradourosReducers, cepReducers, estadosReducers } from './modulos/endereco/endereco';
import { reducerEventos, reducerPesquisaEventos, reducerCadastroEvento, reducerEventoSelecionado, reducerDadosWebEvento } from './modulos/eventos/eventos';
import { pergrespReducer, pergCadAtualizaReducer, respCadAtualizaReducer, respostasPesquisaReducer } from './modulos/questionario/questionario';
import { formsPesquisaCamposReducer, formsNovoAtualizaCamposReducer, formsPesquisaCategoriasReducer } from './modulos/forms/forms';
import { 
    loginValidaReducer, 
    atualizaLoginReducer, 
    codigoResetSenhaReducer, 
    pesquisaLoginReducer,
    codigoValidaCadReducer,
    validaCadReducer } from './modulos/login/login';
import { 
    loginGereValidaReducer, 
    loginGerecodigoResetSenhaReducer, 
    loginGerecodigoValidaCadReducer, 
    loginGerevalidaCadReducer,
    pesquisaloginGereReducer,
    atualizaloginGereReducer } from './modulos/logingerenciamento/login';
import { reducerNetWorkErrors } from './modulos/network/erros';
import { emailNovaAtualizaReducer, emailReducerPesquisa, emailReducerPesquisaTipos, emailReducerPesquisaTiposEmails } from './modulos/email/emailReducers';

export default combineReducers({        
    reducerValidaLogin,
    reducerToken,
    reducerTraducoes,
    pesquisaTratamentoReducer,
    pesquisaPaisesReducer,
    tipologradourosReducers,
    reducerEventos,
    reducerPesquisaItem,
    reducerPesquisaSubitem,
    reducerPesquisaCodigoPromocional,
    reducerPesquisaPedidosItens,
    cepReducers,
    pesquisaCargosReducer,
    pergrespReducer,
    formsPesquisaCamposReducer,
    getCredencialReducer,
    pesquisaCadastroReducer,
    loginValidaReducer,
    atualizaLoginReducer, 
    codigoResetSenhaReducer, 
    pesquisaLoginReducer,
    reducerPesquisaEventos,
    estadosReducers,
    reducerCadastroEvento,
    reducerSubitemSelecionado,
    reducerCodigoPromocionalSelecionado,
    reducerEventoSelecionado,
    reducerSubitemNovoAtualiza,
    reducerPesquisaProdPreco, 
    reducerProdPrecoNovoAtualiza, 
    reducerProdPrecoSelecionado,
    reducerCodigoPromocionalNovoAtualiza,
    traducoesNovaAtualizaReducer,
    formsNovoAtualizaCamposReducer,
    pergCadAtualizaReducer,
    respCadAtualizaReducer, 
    respostasPesquisaReducer,
    codigoValidaCadReducer,
    validaCadReducer,
    reducerNetWorkErrors,
    loginGereValidaReducer, 
    loginGerecodigoResetSenhaReducer, 
    loginGerecodigoValidaCadReducer, 
    loginGerevalidaCadReducer,
    pesquisaloginGereReducer,
    atualizaloginGereReducer,
    reducerDadosWebEvento,
    formsPesquisaCategoriasReducer,
    emailNovaAtualizaReducer, 
    emailReducerPesquisa,
    emailReducerPesquisaTipos,
    emailReducerPesquisaTiposEmails,
    pesquisaCredencialComPedidoReducer
});